import React from 'react';
import SvgIcon from 'utils/SvgIcon';

const TemplateIcon = ({ fillColor, hoverFill, style }) => (
  <SvgIcon
    {...{ fillColor, hoverFill, style }}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V6V12V15C1.5 15.8284 2.17157 16.5 3 16.5H15C15.8284 16.5 16.5 15.8284 16.5 15V12V6V3C16.5 2.17157 15.8284 1.5 15 1.5ZM3 15V12H15V15H3ZM3 6H15V3H3V6ZM3 10.5V7.5H15V10.5H3Z"
    />
  </SvgIcon>
);

export default TemplateIcon;
